import {deserialize, inheritSerialization} from 'cerialize';

import {Logement} from '../../logement';
import {Entity} from '../../entity';
import {User} from '../../user';

@inheritSerialization(Entity)
export class EnedisAccessToken extends Entity {
  @deserialize
  id: number;

  @deserialize
  user: User;

  @deserialize
  logement: Logement;
}
